import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SortDownArrow } from "../../assets/svg";
import Action from "../../components/common/Action";
import Toggles from "../../components/common/Toggles";
import Breadcrumb from "../../components/common/BreadCrumb";
import DebounceSearch from "../../components/common/DebounceSearch";
import CustomTable from "../../components/customTable/CustomTable";
import RippleLoader from "../../components/loader/RippleLoader";
import { AddButton } from "../../components/micro/input";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import ResetPin from "./ResetPin";
import ReactSelect from "react-select";
import SuccessReset from "./SuccessReset";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTechnician,
  getcompanyList,
  getTechnicianList,
  resetPin,
  updateTechnicianStatus,
} from "../../redux/technician/slice";
import ResetPassword from "./ResetPassword";
import { newPassword } from "../../redux/auth/slice";

const mockRoles = [
  { id: 1, value: "electrician", label: "Electrician" },
  { id: 2, value: "gas", label: "Gas" },
  { id: 3, value: "exhaust", label: "Exhaust" },
  { id: 4, value: "plumbing", label: "Plumbing" },
  { id: 5, value: "electrician_plumbing", label: "Electrician & Plumbing" },
];

const Technicians = () => {
  const [searchValue, setSearchValue] = useState("");
  const [activeTab, setActiveTab] = useState("active");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showConfirmPinPopup, setShowConfirmPinPopup] = useState(false);
  const [showConfirmPasswordPopup, setShowConfirmPasswordPopup] =
    useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [formValues, setFormValues] = useState({
    id: "",
    pin: "",
    confirmPin: "",
  });

  const [allCompanyArray, setAllCompanyListArray] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedComapny, setSelectedCompany] = useState(null);
  const [confirmArchive, setConfirmArchive] = useState(false);
  const [confirmUnarchive, setConfirmUnarchive] = useState(false);
  const [technicianIdToArchive, setTechnicianIdToArchive] = useState(null);
  const [technicianIdToUnarchive, setTechnicianIdToUnarchive] = useState(null);
  const [technicianIdToDelete, setTechnicianIdToDelete] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSuccessType, setShowSuccessType] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Selector
  const {
    techniciansList,
    techniciansListLoading,
    companyList,
    companyListLoading,
  } = useSelector((store) => ({
    techniciansList: store?.technicianData?.getTechnicianListStatus?.data,
    techniciansListLoading: store?.technicianData?.loading,
    // Comapny List
    companyList: store?.technicianData?.getcompanyListStatus?.data,
    companyListLoading: store?.technicianData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getTechnicianList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        status: activeTab === "archived" ? "archive" : activeTab,
        company_name: selectedComapny?.value ?? "",
        type: selectedType?.value ?? "",
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
      })
    );
  }, [
    dispatch,
    searchValue,
    pageCount,
    pageLimit,
    activeTab,
    selectedComapny,
    selectedType,
    sortBy,
    sortDirection,
  ]);

  useEffect(() => {
    dispatch(getcompanyList());
  }, []);

  useEffect(() => {
    if (companyList?.data) {
      let data = companyList?.data?.map((e) => ({ label: e, value: e }));
      setAllCompanyListArray(data);
    }
  }, [companyList]);

  const updateStatus = (element, status, isActive) => {
    dispatch(
      updateTechnicianStatus({
        id: element?.id,
        data: {
          status: status,
          is_active: isActive,
        },
      })
    ).then((res) => {
      if (res.type === "updateTechnicianStatus/fulfilled") {
        dispatch(
          getTechnicianList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            company_name: selectedComapny?.value ?? "",
            type: selectedType?.value ?? "",
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
          })
        );
      }
    });
  };

  const handleToggle = (element) => {
    const newStatus = element.status === "active" ? "inactive" : "active";
    const isActive = newStatus === "active";

    updateStatus(element, newStatus, isActive);
  };

  const handleArchive = () => {
    const technicianToArchive = techniciansList?.data?.data?.find(
      (technician) => technician.id === technicianIdToArchive
    );
    if (technicianToArchive) {
      updateStatus(technicianToArchive, "archive", false);
    }
    setConfirmArchive(false);
  };

  const handleResetPin = async () => {
    setIsLoading(true);
    const payload = {
      id: formValues?.id,
      pin: String(formValues?.pin),
      confirm_pin: String(formValues?.confirmPin),
    };

    try {
      const response = await dispatch(resetPin(payload));
      if (response.type === "resetPin/fulfilled") {
        setShowSuccessModal(true);
        setShowSuccessType("pin");
      } else {
        setShowSuccessModal(false);
      }
    } finally {
      setIsLoading(false);
      setShowConfirmPinPopup(false);
    }
  };

  const handleResetPassword = async () => {
    setIsLoading(true);
    const payload = {
      email: formValues?.id,
      password: formValues?.password,
      confirmPassword: formValues?.confirmPassword,
    };

    try {
      const response = await dispatch(newPassword(payload));
      if (response.type === "newPassword/fulfilled") {
        setShowSuccessModal(true);
        setShowSuccessType("password");
      } else {
        setShowSuccessModal(false);
      }
    } finally {
      setIsLoading(false);
      setShowConfirmPasswordPopup(false);
    }
  };

  const handleResetPinClose = () => {
    setShowConfirmPinPopup(false);
    setShowConfirmPasswordPopup(false);
  };

  const handleUnarchive = () => {
    const technicianToUnarchive = techniciansList?.data?.data?.find(
      (technician) => technician.id === technicianIdToUnarchive
    );
    if (technicianToUnarchive) {
      updateStatus(technicianToUnarchive, "active", true);
    }
    setConfirmUnarchive(false);
  };

  const deleteTechnicianId = () => {
    setIsLoading(true);
    if (!technicianIdToDelete) return;
    dispatch(deleteTechnician(technicianIdToDelete)).then((res) => {
      if (res.type === "deleteTechnician/fulfilled") {
        dispatch(
          getTechnicianList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            company_name: selectedComapny?.value ?? "",
            type: selectedType?.value ?? "",
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
          })
        );
      }
      setIsLoading(false);
      setConfirmDelete(false);
    });
  };

  // Table Headers
  const ColumnHeaders = () => (
    <>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-14">
        ID
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Name</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "name" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("company_name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Company</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "company_name"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Mobile
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Email
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Working Hours
      </th>
      {activeTab === "active" && (
        <th
          scope="col"
          className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
        >
          <div className="flex items-center">
            <span>Status</span>
          </div>
        </th>
      )}

      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Type
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Action
      </th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(techniciansList?.data?.data || [])?.map((element, index) => {
        return (
          <tr
            key={element?.id}
            className="font-Proxima text-sm shadow-sm text-mgrey hover:bg-lightprimaryorange"
          >
            <td className="px-4 py-3 ">{element?.id}</td>
            <td className="px-4 py-3 truncate">
              {element?.full_name
                ? element?.full_name
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase())
                : "-"}
            </td>
            <td className="px-4 py-3 truncate">
              {element?.company_name
                ? element?.company_name
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase())
                : "-"}
            </td>
            <td className="px-4 py-3 truncate">{element?.phone}</td>
            <td className="px-4 py-3 truncate">{element?.email}</td>
            <td className="px-4 py-3">
              {element?.start_time} - {element?.end_time}
            </td>

            {activeTab === "active" && (
              <td className="px-4 py-3">
                <Toggles
                  checked={element?.status === "active"}
                  toggleFor={element?.id}
                  onChange={() => handleToggle(element)}
                />
              </td>
            )}

            <td className="px-4 py-3">
              {(() => {
                if (
                  element?.types &&
                  Array.isArray(element.types) &&
                  element.types.length > 0
                ) {
                  return element.types
                    .map((typeValue) => {
                      const role = mockRoles.find(
                        (role) => role.value === typeValue
                      );
                      return role?.label || typeValue;
                    })
                    .filter(Boolean)
                    .join(", ");
                }
                if (
                  element?.technician_types &&
                  Array.isArray(element?.technician_types) &&
                  element?.technician_types.length > 0
                ) {
                  return element.technician_types
                    .map((techType) => {
                      const typeValue =
                        typeof techType === "object"
                          ? techType?.type
                          : techType;
                      const role = mockRoles.find(
                        (role) => role.value === typeValue
                      );
                      return role?.label || typeValue;
                    })
                    .filter(Boolean)
                    .join(", ");
                }
                if (element?.type) {
                  const role = mockRoles.find(
                    (role) => role.value === element?.type
                  );
                  return role?.label || element?.type;
                }
                return "-";
              })()}
            </td>
            <td className="flex px-4 py-3">
              {activeTab === "active" ? (
                <Action
                  optionList={
                    <>
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer font-Proxima text-base"
                        onClick={() =>
                          navigate("/create-edit-technician-account", {
                            state: { technician: element, mode: "edit" },
                          })
                        }
                      >
                        View/Edit
                      </li>
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer font-Proxima text-base"
                        onClick={() => {
                          setConfirmArchive(true);
                          setTechnicianIdToArchive(element?.id);
                        }}
                      >
                        Archive
                      </li>
                      {element?.email_verified_at && !element?.pin ? (
                        <li
                          className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer font-Proxima text-base"
                          onClick={() => {
                            setTechnicianIdToArchive(element?.id);
                            setFormValues({
                              id: element?.email,
                              pin: formValues?.password,
                              confirmPin: formValues?.confirmPassword,
                            });
                            setShowConfirmPasswordPopup(true);
                          }}
                        >
                          Reset Password
                        </li>
                      ) : (
                        <li
                          className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer font-Proxima text-base"
                          onClick={() => {
                            setTechnicianIdToArchive(element?.id);
                            setFormValues({
                              id: element?.id,
                              pin: formValues?.pin,
                              confirmPin: formValues?.confirmPin,
                            });
                            setShowConfirmPinPopup(true);
                          }}
                        >
                          Reset 4-digit pin
                        </li>
                      )}
                    </>
                  }
                />
              ) : (
                <Action
                  optionList={
                    <>
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                        onClick={() => {
                          setTechnicianIdToUnarchive(element?.id);
                          setConfirmUnarchive(true);
                        }}
                      >
                        Unarchive
                      </li>
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                        onClick={() => {
                          setConfirmDelete(true);
                          setTechnicianIdToDelete(element?.id);
                        }}
                      >
                        Delete
                      </li>
                    </>
                  }
                />
              )}
            </td>
          </tr>
        );
      })}
    </>
  );

  return (
    <>
      <div className="space-y-5">
        <div className="flex justify-between items-start">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3 ">
              {activeTab === "active"
                ? "Technicians"
                : "Archived Technician Account"}
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={
                activeTab === "active"
                  ? "Technician"
                  : "Archived Technician Account"
              }
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
          {activeTab === "active" ? (
            <AddButton
              value="Add Technician"
              onClick={() =>
                navigate("/create-edit-technician-account", {
                  state: { mode: "create" },
                })
              }
            />
          ) : (
            ""
          )}
        </div>
        <div className="flex justify-end my-8">
          {["active", "archived"].map((tab, index) => (
            <button
              key={tab}
              className={`transition font-Proxima uppercase duration-300 text-sm font-normal px-4 py-1.5
        ${index === 0 ? "!rounded-l !rounded-r-none" : ""}
        ${index === 1 ? "!rounded-r !rounded-l-none" : ""}
        ${
          activeTab === tab
            ? "bg-themeBtn text-white shadow-[0_4px_6px_rgba(0,0,0,0.3)]"
            : "bg-disabletheme text-white shadow-[0_4px_6px_rgba(0,0,0,0.2)]"
        }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="flex items-center space-x-3">
          {activeTab === "active" ? (
            <ReactSelect
              className={"w-full max-w-52 text-black p-0 font-Proxima"}
              id="comapany"
              placeholder="Company"
              options={allCompanyArray}
              isClearable={true}
              getOptionValue={(selectedComapny) => selectedComapny?.value}
              getOptionLabel={(selectedComapny) => selectedComapny?.label}
              value={selectedComapny}
              onChange={(e) => {
                setSelectedCompany(e);
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  border: `1px solid #0000003B`,
                  borderColor: selectedComapny ? "#F15B29" : "#0000003B",
                  borderRadius: "0.3rem",
                  boxShadow: "none",
                  "&:hover": {
                    border: "1px solid #0000003B",
                  },
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? "#F15B29" : "white",
                  "&:active": {
                    backgroundColor: state.isSelected
                      ? "#F15B29"
                      : "rgba(0, 0, 0, 0.04)",
                  },
                }),
              }}
            />
          ) : (
            ""
          )}

          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="role"
            placeholder="Role"
            options={mockRoles}
            isClearable={true}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={selectedType}
            onChange={(e) => {
              setSelectedType(e);
            }}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedType ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <DebounceSearch
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
        </div>
        {techniciansListLoading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg">
            <CustomTable
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              data={techniciansList?.data}
              overflowVisibleLg={true}
              // loader
              loading={false}
              showPagination={true}
              //show pageLimit
              setPaginationCurrentLimit={setPageLimit}
              paginationCurrentLimit={pageLimit}
              //paginationData
              total={techniciansList?.data?.total}
              current={pageCount}
              paginationData={(crPage) => setPageCount(crPage)}
              lastPage={Math.ceil(techniciansList?.data?.total / pageLimit)}
            />
          </div>
        )}
      </div>
      {confirmArchive && (
        <div>
          <ConfirmationModel
            confirmText={"Archive"}
            onClose={() => {
              setConfirmArchive(false);
            }}
            onConfirm={handleArchive}
          />
        </div>
      )}
      {confirmUnarchive && (
        <div>
          <ConfirmationModel
            confirmText={"Unarchive"}
            onClose={() => {
              setConfirmUnarchive(false);
            }}
            onConfirm={handleUnarchive}
          />
        </div>
      )}
      {showConfirmPinPopup && (
        <div>
          <ResetPin
            id={technicianIdToUnarchive}
            setFormValues={setFormValues}
            formValues={formValues}
            onClose={handleResetPinClose}
            onConfirm={handleResetPin}
            setShowConfirmPinPopup={setShowConfirmPinPopup}
            setShowSuccessModal={setShowSuccessModal}
            isLoading={isLoading}
          />
        </div>
      )}
      {showConfirmPasswordPopup && (
        <div>
          <ResetPassword
            id={technicianIdToUnarchive}
            setFormValues={setFormValues}
            formValues={formValues}
            onClose={handleResetPinClose}
            onConfirm={handleResetPassword}
            setShowConfirmPasswordPopup={setShowConfirmPasswordPopup}
            setShowSuccessModal={setShowSuccessModal}
            isLoading={isLoading}
          />
        </div>
      )}
      {confirmDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              setConfirmDelete(false);
            }}
            onConfirm={deleteTechnicianId}
            isLoading={isLoading}
          />
        </div>
      )}
      {showSuccessModal && (
        <SuccessReset
          onClose={() => setShowSuccessModal(false)}
          showSuccessType={showSuccessType}
        />
      )}
    </>
  );
};

export default Technicians;
